const RequiredIcon = (props: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="0.5"
        width="18"
        height="18"
        rx="5.5"
        stroke={props.stroke || "var(--theme-secondary-400, #F135A3)"}
        strokeWidth="2"
      />
      <path
        d="M9.898 12.376L10.096 10.18L10.258 10.198L8.26 11.548L7.486 10.216L9.646 9.244L9.628 9.352L7.468 8.326L8.242 6.994L10.276 8.416L10.096 8.398L9.898 6.166H11.5L11.302 8.56L11.104 8.434L13.084 7.03L13.84 8.38L11.644 9.406V9.208L13.822 10.198L13.048 11.53L11.086 10.144L11.32 10.18L11.5 12.376H9.898Z"
        fill={props.stroke || "var(--theme-secondary-400, #F135A3)"}
        strokeWidth="2"
      />
    </svg>
  );
};

export { RequiredIcon };
